import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { Cartao } from '../../../../models/empresa/cartao';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { FormBuilder, FormGroup, Validators, FormControl } from '@angular/forms';
import { LoadingService } from '../../../../util/loader.service';
import { ActivatedRoute } from '@angular/router';
import { Subject } from 'rxjs';
import { BsLocaleService } from 'ngx-bootstrap/datepicker';
import { moment } from 'ngx-bootstrap/chronos/test/chain';
import { ControleDeAcessoService } from '../controle-acesso.service';
import { FiltroControleDeAcesso } from '../../../../models/controle-acesso/filtroControleDeAcesso';
import { ControDeAcesso, PaginaAcesso } from '../../../../models/controle-acesso/ControleDeAcesso';
const swal = require('sweetalert');

@Component({
  selector: 'app-modal-visualizacao-permissao',
  templateUrl: './modal-visualizacao-permissao.component.html',
  styleUrls: ['./modal-visualizacao-permissao.component.scss']
})
export class ModalVisualizacaoPermissaoComponent implements OnInit {
  public onClose: Subject<any>;
  record: Array<any>

  constructor(private _bsModalRef: BsModalRef, public loader: LoadingService, private service: ControleDeAcessoService, private route: ActivatedRoute, private _localeService: BsLocaleService) { }

  ngOnInit() {
    this.onClose = new Subject();


  }

  public onCancel(): void {
    const output = {
      reload: false
    };
    this.onClose.next(output);
    this._bsModalRef.hide();
  }

  public onOk(): void {
    const output = {
      reload: true
    };
    this.onClose.next(output);
    this._bsModalRef.hide();
  }
}
